import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 引用API文件
import api from '../../assets/js/common/ServerInterface.js'
// 引用全局过滤器
import dfilters from '../../assets/js/common/GlobalFilters.js'
// 引用 store
import store from '../../assets/js/common/Store.js'
import '../../assets/css/font.css'
import globalFunctions from "../../assets/js/common/GlobalFunction";

// 将API方法绑定到全局
Vue.prototype.$api = api
// 将全局过滤器注册到当前页面的Vue中
Object.keys(dfilters).forEach(key => {
    // console.log(filters[key])
    Vue.filter(key,dfilters[key])
})

//引入全局方法文件中本页面需要用到的方法
Vue.prototype.$byUrlInitValue = globalFunctions.$byUrlInitValue

Vue.use(require('vue-wechat-title'))

new Vue({
    store: store,// 将Store绑定到全局
    router: router,//路由设置
    render: h => h(App)
}).$mount('#app')

